(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipes"] && !Shopify.designMode) return;
  try {
    
  if (!window.__arRecipesBound) {
    window.__arRecipesBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-recipe-video]');
      if (!button) return;
      event.preventDefault();

      var id = button.getAttribute('data-recipe-video');
      var player = document.createElement('div');
      player.className = 'recipes__player';

      var iframe = document.createElement('iframe');
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(id) +
        '?autoplay=1&rel=0&playsinline=1';
      iframe.title = button.getAttribute('aria-label') || '';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      player.appendChild(iframe);
      button.replaceWith(player);
    });

    // YouTube has no maxres thumbnail for every video
    document.addEventListener(
      'error',
      function (event) {
        var img = event.target;
        if (!img || !img.classList || !img.classList.contains('recipes__thumb')) return;
        var fallback = img.getAttribute('data-recipe-fallback');
        if (!fallback) return;
        img.removeAttribute('data-recipe-fallback');
        img.src = fallback;
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();
})();
